<template>
  <div id="banner" class="banner">
    <Swiper v-if="bys == 'swipe'" :slide="banner" :swiperParam="sp" :isBack=1></Swiper>
    <div v-else class="pbi_wrapper"><slot name="pinb"></slot></div>
  </div>
</template>

<script>
  import Swiper from "./Swiper.vue";
  export default {
    name: "Banner",
    props: ["bys"],
    components: { Swiper },
    data: function() {
      return {
        banner: [require("../../assets/banner/banner_1.jpg"), require("../../assets/banner/banner_2.jpg"), require("../../assets/banner/banner_3.jpg"), require("../../assets/banner/banner_4.jpg")],
        sp: {
          pagination: {
            el: ".swiper-pagination"
          },
          loop: true,
          autoplay: true
        }
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .banner {
    width: 100vw;
    max-height: 100vh;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
    }
    .pbi_wrapper {
      position: relative;
      z-index: 1;
      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.20);
        position: absolute;
        z-index: 999;
        top: 0;
        left: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Banner.vue